module.exports = __webpack_public_path__ + "img/bg-03.e475a766.jpg";